import { ReactNode } from 'react';
import cx from 'classnames';

import s from './styles.module.scss';

interface ISidebar {
  className?: string;
  children: ReactNode;
}

const Sidebar = ({ className, children }: ISidebar) => <div className={cx(className, s.sidebar)}>{children}</div>;

export { Sidebar };
export { Item } from './item';
export { Sector } from './sector';
export { SidebarCollapsed } from './collapsed';
